export default function initEnableAnimations(){
    setTimeout(function () {
        $("body.disable-animations-all").removeClass("disable-animations-all");
    }, 333);
}